import DatePicker from "react-datepicker";
import { ko } from "date-fns/esm/locale";
import DateFunc from '@/lib/lyg/date_func';
import { customHeaderFunc } from '@/pcomponents/common/date_picker/custom_header';
import { CustomInputSearch } from '@/pcomponents/common/date_picker/custom_input';
import strFunc from "@/lib/lyg/string";
import { useState, useRef, useEffect } from 'react';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";

function SearchArea(props: any) {
  let myProps = {
    listOpt: {},
    setListOpt: (inData: any) => { },
    list: (inData: any) => { },
    goDelete: (inData: any) => { },
    is_show_detail: false,
    set_is_show_detail: (inData: boolean) => { },
    is_show_order_det_search: false,
    is_show_del_btn: true,
    is_show_comp_search: true,
    ...props
  };
  let listOpt = myProps.listOpt;

  const [mcomp_group_arr, set_mcomp_group_arr] = useState<any>([]);
  const [mcomp_arr, set_mcomp_arr] = useState<any>([]);

  const get_mcomp_by_ajax = (inData:any) => {
    let form_json_data: any = {
      order_id: "a_name",
      s_belong_sort: listOpt.s_mcomp_belong_sort,
      s_is_use: "1",
      is_paging: "",
      ...inData
    };
    if (form_json_data.s_belong_sort == "") {
      set_mcomp_arr([]);
      return;
    }

    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/mcomp/mcomp/list',
      form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_mcomp_arr(response.data["data"]["info_arr"]);
        } else {

        }
      });
  };

  const get_mcomp_group_by_ajax = () => {
    let form_json_data: any = {
      order_id: "a_name",
      is_paging: ""
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/mcomp/group/list',
      form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_mcomp_group_arr(response.data["data"]["info_arr"]);
        } else {

        }
      });
  };

  const on_change_search_input = (e: any) => {
    let name = e.target.name;
    let value = e.target.value;

    let change_list_opt: any = {
      ...myProps.listOpt,
    };
    change_list_opt[name] = value;

    if(name=="s_mcomp_belong_sort"){
      get_mcomp_by_ajax({ s_belong_sort: value });
    }

    myProps.list({
      ...change_list_opt,
      now_page: 1
    });
  };

  const onChangeDatePicker = (key: string, date: Date) => {
    let date_str = DateFunc.get_date_format(date, "Y-m-d");
    let change_list_opt = {
      now_page: 1,
      [key]: date_str
    };
    if (key == "s_start_date") {
      if (listOpt.s_end_date < date_str) {
        change_list_opt["s_end_date"] = date_str;
      }
    }
    myProps.list(change_list_opt);
  };

  const goChangeDateMonth = (month: number) => {
    let selected_date = listOpt.s_start_date;
    if (selected_date == "") {
      selected_date = DateFunc.get_date_format(new Date(), "Y-m-d");
    }
    let row_year = selected_date.substring(0, 4);
    let row_month = strFunc.str_pad({ "str": month, "pad_length": 2 });
    selected_date = row_year + "-" + row_month + "-01";

    let start_date = DateFunc.get_date_format(new Date(selected_date), "Y-m-01");
    let end_date = DateFunc.get_date_format(new Date(selected_date), "Y-m-t");
    myProps.list({
      now_page: "1",
      s_start_date: start_date,
      s_end_date: end_date,
    });
  };

  const goDateDayChange = (inData: any) => {
    let opt_obj = {
      "sort": "month",//day
      "pre_next": "pre",
      ...inData
    };
    //next,pre
    let selected_date = listOpt.s_start_date;
    if (selected_date == "") {
      selected_date = DateFunc.get_date_format(new Date(), "Y-m-d");
    }
    let change_date_obj = new Date(selected_date);
    if (opt_obj.pre_next == "pre") {
      if (opt_obj.sort == "month") {
        change_date_obj = DateFunc.get_change_date(new Date(selected_date), 'month', -1);
      } else {
        change_date_obj = DateFunc.get_change_date(new Date(selected_date), 'day', -1);
      }
    } else if (opt_obj.pre_next == "next") {
      if (opt_obj.sort == "month") {
        change_date_obj = DateFunc.get_change_date(new Date(selected_date), 'month', +1);
      } else {
        change_date_obj = DateFunc.get_change_date(new Date(selected_date), 'day', +1);
      }
    }

    let start_date = DateFunc.get_date_format(change_date_obj, "Y-m-d");
    let end_date = DateFunc.get_date_format(change_date_obj, "Y-m-d");
    if (opt_obj.sort == "month") {
      start_date = DateFunc.get_date_format(change_date_obj, "Y-m-01");
      end_date = DateFunc.get_date_format(change_date_obj, "Y-m-t");
    }

    myProps.list({
      now_page: "1",
      s_start_date: start_date,
      s_end_date: end_date,
    });
  };

  let year_month_num_arr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  return (
    <div>
      <div className="my_flex_center">
        <span className="text-blue-700">
          {listOpt.s_start_date.substring(5, 7)} 월
        </span>
        {year_month_num_arr.map((row_num) => {
          let btn_class_name = "btn btn-dark ml-1";
          let select_month_num = parseInt(listOpt.s_start_date.substring(5, 7));
          if (select_month_num == row_num) {
            btn_class_name = "btn btn-blue ml-1";
          }
          return (
            <button key={row_num} className={btn_class_name}
              onClick={() => { goChangeDateMonth(row_num); }} >{row_num}</button>
          );
        })}
        <div style={{ display: "inline-block", width: 90 }}>
          <DatePicker
            wrapperClassName="pl-1"
            selected={listOpt.s_start_date != "" ? new Date(listOpt.s_start_date) : null}
            onChange={(date: Date) => {
              onChangeDatePicker("s_start_date", date);
            }}
            locale={ko}
            dateFormat="yyyy-MM-dd"
            customInput={<CustomInputSearch />}
            renderCustomHeader={customHeaderFunc}
          />
        </div>
        ~
        <div style={{ display: "inline-block", width: 90 }}>
          <DatePicker
            wrapperClassName="pl-1"
            selected={listOpt.s_end_date != "" ? new Date(listOpt.s_end_date) : null}
            onChange={(date: Date) => {
              onChangeDatePicker("s_end_date", date);
            }}
            locale={ko}
            dateFormat="yyyy-MM-dd"
            customInput={<CustomInputSearch />}
            renderCustomHeader={customHeaderFunc}
          />
        </div>
        <button className="btn-s2 btn-dark ml-1" onClick={() => { goDateDayChange({ pre_next: "pre" }); }}>◀</button>
        <button className="btn-s2 btn-dark ml-1" onClick={() => { goDateDayChange({ pre_next: "next" }); }}>▶</button>
        {myProps.is_show_comp_search &&
          <>
            <select className="search-input" name="s_mcomp_belong_sort" value={listOpt.s_mcomp_belong_sort} 
              onChange={on_change_search_input}>
              <option value="">소속</option>
              <option value="plani">직영</option>
              <option value="etc">프랜차이즈</option>
            </select>
            <select className="search-input" name="s_mcomp_seq" value={listOpt.s_mcomp_seq} onChange={on_change_search_input}>
              <option value="">학원</option>
              {mcomp_arr.map((item: any, idx: number) => {
                return (
                  <option key={idx} value={item.a_seq}>{item.a_name}</option>
                );
              })}
            </select>
          </>
        }
        {/* 
        <select className="search-input" name="s_in_out" value={listOpt.s_in_out} onChange={on_change_search_input}>
          <option value="">구분</option>
          <option value="out">판매</option>
          <option value="in">입고</option>
        </select>
        <select className="search-input" name="s_mcomp_sort_detail" value={listOpt.s_mcomp_sort_detail} onChange={on_change_search_input}
          style={{ width: "70px" }}>
          <option value="">구분</option>
          <option value="empty">일반</option>
          <option value="sntbr">수앤탐브릿지</option>
          <option value="plani">플랜아이</option>
          <option value="growple">그로플</option>
        </select>
        <select className="search-input" name="s_mcomp_group_seq" value={listOpt.s_mcomp_group_seq} onChange={on_change_search_input}
          style={{ width: "70px" }}>
          <option value="">그룹</option>
          {mcomp_group_arr.map((item: any, idx: number) => {
            return (
              <option key={idx} value={item.a_seq}>{item.a_name}</option>
            );
          })}
        </select>
        <input type="text" name="s_title_like" value={listOpt.s_title_like} onChange={on_change_search_input}
          className="search-input pl-1" placeholder="제목" style={{ width: "80px" }} />
        <input type="text" name="s_user_name_like" value={listOpt.s_user_name_like} onChange={on_change_search_input}
          className="search-input pl-1" placeholder="주문자" style={{ width: "80px" }} /> */}
        {myProps.is_show_order_det_search &&
          <>
            <select className="search-input" name="s_product_type" value={listOpt.s_product_type} onChange={on_change_search_input}
              style={{ width: "70px" }}>
              <option value="">구분</option>
              <option value="mtextbook">교재</option>
              <option value="mtextbook_period">온라인</option>
              <option value="deliver_cost">배송비</option>
            </select>
            <input type="text" name="s_product_name" value={listOpt.s_product_name} onChange={on_change_search_input}
              className="search-input ml-1" placeholder="상품명" style={{ width: "80px" }} />
          </>
        }
        {myProps.is_show_comp_search &&
          <input type="text" name="s_mcomp_name_like" value={listOpt.s_mcomp_name_like} onChange={on_change_search_input}
            className="search-input pl-1" placeholder="학원" style={{ width: "80px" }} />
        }
        <button className='btn btn-dark'>검색</button>
        {myProps.is_show_del_btn &&
          <button className='btn btn-red'
            onClick={() => {
              myProps.goDelete({});
            }}>삭제</button>
        }

        <span className="ml-2">
          <label>
            <input type="checkbox" className="mr-1" checked={myProps.is_show_detail}
              onChange={(e) => { myProps.set_is_show_detail(e.target.checked); }} />
            주문상세보기
          </label>
        </span>
      </div>
    </div>
  );
};
export default SearchArea;